import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { recruitNowWebhookQueryKeys } from "./queryKeys";
import type { WebhookRegistration } from "./useClientWebhookRegistrations";

import { instance } from "@/lib/axios/instance";

export interface UseWebhookRegistrationByIdParams {
  clientId?: string | null;
  registrationId?: string | null;
}

export function useWebhookRegistrationById({
  clientId,
  registrationId,
}: UseWebhookRegistrationByIdParams = {}) {
  return useQuery<WebhookRegistration, AxiosError>({
    queryKey: recruitNowWebhookQueryKeys.registrationById(clientId, registrationId),
    queryFn: async () => {
      if (!clientId || !registrationId) {
        throw new Error("clientId and registrationId are required");
      }
      const response = await instance.get<WebhookRegistration>(
        `/api/v2/Webhooks/RecruitNow/Clients/${clientId}/Registrations/${registrationId}`
      );
      return response.data;
    },
    enabled: !!clientId && !!registrationId,
  });
}
